"use strict";
// TODO: flush on beforeunload
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvaluationSummaryAggregator = void 0;
// TODO: should we retry the data chunk if a flush fails?
// TODO: pause when offline?
// TODO: flush when we receive a config update (or as a result of a context update...but that should trigger a config update anyway)
const periodicSync_1 = require("./periodicSync");
class EvaluationSummaryAggregator extends periodicSync_1.PeriodicSync {
    constructor(client, maxKeys, syncInterval) {
        super(client, "EvaluationSummaryAggregator", syncInterval !== null && syncInterval !== void 0 ? syncInterval : 30000);
        this.maxKeys = maxKeys;
    }
    record(config) {
        if (this.data.size >= this.maxKeys)
            return;
        if (config === null || config === void 0 ? void 0 : config.configEvaluationMetadata) {
            const _a = config.configEvaluationMetadata, { type } = _a, metadata = __rest(_a, ["type"]);
            const key = `${config.key},${type}`;
            // create counter entry if it doesn't exist
            if (!this.data.has(key)) {
                this.data.set(key, Object.assign(Object.assign({}, metadata), { selectedValue: { [config.type]: config.value }, count: 0 }));
            }
            // increment count
            const counter = this.data.get(key);
            if (counter) {
                counter.count += 1;
            }
        }
    }
    flush(toShip, startAtWas) {
        var _a;
        this.logInternal(`Flushing ${toShip.size} summaries`);
        const summaries = {
            start: startAtWas.getTime(),
            end: new Date().getTime(),
            summaries: EvaluationSummaryAggregator.summaries(toShip),
        };
        (_a = this.client.telemetryUploader) === null || _a === void 0 ? void 0 : _a.post(this.events(summaries)).then(() => {
            this.logInternal(`Uploaded ${toShip.size} summaries`);
        });
    }
    static summaries(data) {
        return Array.from(data).map((entry) => {
            const [configKey, configType] = entry[0].split(",");
            const counter = entry[1];
            const counters = [counter]; // this client only ever has one set of counter info per key
            return {
                key: configKey,
                type: configType,
                counters,
            };
        });
    }
    events(summaries) {
        const event = { summaries };
        return {
            instanceHash: this.client.instanceHash,
            events: [event],
        };
    }
}
exports.EvaluationSummaryAggregator = EvaluationSummaryAggregator;
